import { render } from "./TRTCTable.vue?vue&type=template&id=0fbc32b8"
import script from "./TRTCTable.vue?vue&type=script&lang=js"
export * from "./TRTCTable.vue?vue&type=script&lang=js"

import "./TRTCTable.vue?vue&type=style&index=0&id=0fbc32b8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__